import { Patient } from 'src/app/core/models/patient.model';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { combineLatest } from 'rxjs';
import { PatientService } from 'src/app/core/services/patient.service';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-patients-list',
  templateUrl: './patients-list.component.html',
  styleUrls: ['./patients-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientsListComponent implements OnInit {

  @Input()
  set filters(filters: string) {
    this.filters$.next(filters);
  }

  filters$ = new BehaviorSubject<string | null>(null);
  patients$ = this.getPatients();

  @Output() patientSelected = new EventEmitter();

  constructor(
    private patientService: PatientService
  ) { }

  ngOnInit(): void {
  }

  trackByFn(index, item) {
    return item.id;
  }

  private getPatients(): Observable<Patient[]> {
    return combineLatest([
      this.filters$,
      this.patientService.patients$
    ]).pipe(
      map(([filters, patients]) => {
        if (!filters) {
          return patients;
        }
        return patients.filter(patient => patient.name?.toLowerCase().includes(filters));
      }),
      shareReplay(1)
    );
  }

}
